import type { ReactNode } from "react"
import { cn } from "@/lib/utils"
import { ChartContextChip } from "../ChatInput/ChartContextChip"
import type { UserMessage } from "../types/chat"

export interface ChatMessageUserProps {
  message: UserMessage
  onEdit?: (id: number) => void
  editable?: boolean
  actionsSlot?: ReactNode
  className?: string
}

export function ChatMessageUser({
  message,
  onEdit,
  editable = false,
  actionsSlot,
  className,
}: ChatMessageUserProps) {
  return (
    <div className={cn("flex justify-end group", className)}>
      <div className="max-w-[85%] flex flex-col items-end gap-1.5">
        <div className="max-w-full min-w-0 bg-muted/50 rounded-2xl px-3 pt-2 pb-3 text-body text-foreground whitespace-pre-wrap break-words leading-relaxed">
          {message.content}
        </div>
        {message.attachments && message.attachments.length > 0 && (
          <div className="flex flex-wrap gap-1 justify-end">
            {message.attachments.map((a, i) =>
              a.kind === "chart" ? (
                <ChartContextChip key={i} label={a.name} />
              ) : (
                <span
                  key={i}
                  className="text-caption text-muted-foreground border border-border rounded px-1.5 py-0.5 bg-muted"
                >
                  {a.name}
                </span>
              ),
            )}
          </div>
        )}
        {(editable || actionsSlot) && (
          <div className="opacity-0 group-hover:opacity-100 transition-opacity flex items-center gap-1">
            {editable && onEdit && (
              <button
                type="button"
                onClick={() => onEdit(message.id)}
                className="text-caption text-muted-foreground hover:text-foreground cursor-pointer"
              >
                Edit
              </button>
            )}
            {actionsSlot}
          </div>
        )}
      </div>
    </div>
  )
}
